import type { UserResponse } from '@heidi/workspace/contracts';
import type { QueryClient } from '@tanstack/react-query';

export interface FdeDataConfig {
  useAuthToken: () => string | null | undefined;
  queryClient: QueryClient;
  /** The app's user-query hook, injected whole for auth gating. */
  useQueryUser: <T>(select?: (user: UserResponse | undefined) => T) => { data?: T };
}

let config: FdeDataConfig | null = null;

export const configureFdeData = (next: FdeDataConfig): void => {
  config = next;
};

export const getFdeDataConfig = (): FdeDataConfig => {
  if (!config) {
    throw new Error(
      '[fde/data] not configured — see src/composition/hosts/fde/fde-data-wiring.ts'
    );
  }
  return config;
};

export const resetFdeDataConfigForTests = (): void => {
  config = null;
};
